import { lazy, Suspense } from 'react'
import HeaderIframe from 'src/components/common/HeaderIframe'
import { useUI } from 'src/sdk/ui'
import type { PropsWithChildren } from 'react'
import { Helmet } from 'react-helmet-async'

const CartSidebar = lazy(() => import('src/components/cart/CartSidebar'))
const Toast = lazy(() => import('src/components/ui/Toast'))

function Iframe({ children }: PropsWithChildren) {
  const { displayMinicart, toasts } = useUI()

  return (
    <>
      <Helmet
        htmlAttributes={{ class: 'overflow-hidden' }}
        bodyAttributes={{ class: 'bg-transparent' }}
      />

      <HeaderIframe />

      <main>{children}</main>

      {displayMinicart && (
        <Suspense fallback={null}>
          <CartSidebar />
        </Suspense>
      )}

      {toasts.length > 0 && (
        <Suspense fallback={null}>
          <Toast />
        </Suspense>
      )}
    </>
  )
}

export default Iframe
